import React, { useEffect, useState } from "react";
import { FaFacebookF, FaInstagram, FaTwitter } from "react-icons/fa";

import BASE_URL from "../../config";

export default function Footer() {
  const [contacts, setContacts] = useState([]);

  // FETCH CONTACTS
  useEffect(() => {
    fetch(`${BASE_URL}/api/getContact.php`)
      .then((res) => res.json())
      .then((data) => setContacts(data));
  }, []);

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* ABOUT */}
        <div className="footer-section">
          <h3>અમારા વિશે</h3>

          <p>
            અમારી સોસાયટી મહિલાઓને આર્થિક રીતે મજબૂત બનાવવા માટે લોન અને વીમા
            સુવિધાઓ પૂરી પાડે છે અને સહકારી ભાવનાથી કાર્ય કરે છે.
          </p>
        </div>

        {/* QUICK LINKS */}
        <div className="footer-section">
          <h3>ઝડપી લિંક્સ</h3>

          <ul>
            <li>
              <a href="/home">હોમ</a>
            </li>

            <li>
              <a href="/about">અમારા વિશે</a>
            </li>

            <li>
              <a href="/gallery">પ્રવૃત્તિઓ</a>
            </li>

            <li>
              <a href="/join">સંપર્ક</a>
            </li>
          </ul>
        </div>

        {/* DYNAMIC OFFICE SECTIONS */}
        {contacts.map((contact) => (
          <div className="footer-section" key={contact.id}>
            <h3>{contact.office_name}</h3>

            <p>{contact.address}</p>

            <p>
              મો. {contact.phone1}
              {contact.phone2 && ` / ${contact.phone2}`}
            </p>
          </div>
        ))}

        {/* TIMING + SOCIAL */}
        <div className="footer-section">
          <h3>કામકાજ નો સમય</h3>

          {contacts.length > 0 && <p>{contacts[0].timing}</p>}

          <p>બીજા તથા ચોથા શનિવારે રાજા રહેશે.</p>

          {/* <h3>અમને ફોલો કરો</h3>

          <div className="social-icons">
            <a href="#">
              <FaFacebookF />
            </a>

            <a href="#">
              <FaInstagram />
            </a>

            <a href="#">
              <FaTwitter />
            </a>
          </div> */}
        </div>
      </div>

      <div className="footer-bottom">
        <p></p>
        <p>
          © {new Date().getFullYear()} શ્રી વૈભવલક્ષ્મી મહિલા કો-ઓ. થ્રીફ્ટ,
          ક્રેડિટ એન્ડ કન્ઝયુમર સોસાયટી લિ.
        </p>
        <p style={{ color: "white" }}>
          Develpoed By:{" "}
          <a
            href="https://lifetimeinfotech.in/"
            style={{ color: "rgb(149, 187, 209)" }}
          >
            Lifetimeinfotech.in
          </a>
        </p>
      </div>
    </footer>
  );
}
